import { defineNuxtPlugin } from '#app'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

function getIanaTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
}

function getUtcOffsetMinutes(): number {
  return -new Date().getTimezoneOffset()
}

const useHeaders = (headers: Headers) => {
  return {
    addHeader: (key: string, value: string) => {
      headers.set(key, value)
    },
    setAuthorizationBearer: (token: string) => {
      headers.set('Authorization', `Bearer ${token}`)
    },
  }
}

export default defineNuxtPlugin(async () => {
  const tz = window ? getIanaTimeZone() : 'UTC'
  const offsetMinutes = window ? getUtcOffsetMinutes() : 0

  const config = useRuntimeConfig()
  const publicVariables = config.public

  const API_HOST = publicVariables.API_URL || 'http://localhost:9972'

  const auth = useAuth()
  const token = auth.accessToken

  const api = $fetch.create({
    baseURL: API_HOST,
    onRequest({ options }) {
      const headers = useHeaders(options.headers)

      headers.addHeader('X-Timezone', tz)
      headers.addHeader('X-Utc-Offset-Minutes', String(offsetMinutes))

      if (!token.value) {
        console.warn('No access token found, skipping API request.')
        return
      }

      headers.setAuthorizationBearer(token.value)
    },
  })

  return {
    provide: {
      api
    },
  }
})
